import React from "react";
import { LayoutSimple } from "root/client/src/_layoutSimple";
import { Layout } from "root/client/src/Layout";

export function SwitchLayout(props: { layout: "full" | "simple"; children: JSX.Element }) {
  const useSimple = props.layout === "simple";

  return useSimple ? <LayoutSimple>{props.children}</LayoutSimple> : <Layout>{props.children}</Layout>;
}
